export default __webpack_public_path__ + "static/media/logo-transparente-solo-gato.c78c616d.png";